export default {
  getUuid: state => state.uuid,
  getIsEditing: state => state.isEditing,
  getLoading: state => state.loading,
  getCurrentStep: state => state.currentStep,
  getSteps: state => state.steps,
  getStepNameRoutes: state => state.step_name_routes,
  getIndexStepsAlreadyVisited: state => state.indexStepsAlreadyVisited,
  getPreviousRoute: state => state.previousRoute,

  getFullReport: state => state.report,
  getTitle: state => state.report.title,
  getPublicationDate: state => state.report.publicationDate,
  getExpirationDate: state => state.report.expirationDate,
  getRead: state => state.report.read,
  getText: state => state.report.text,
  getActive: state => state.report.active,
  getProviderId: state => state.report.providerId,
  getUploads: state => state.report.uploads,
  getFormatedUploads: state => state.report.formatedUploads,
  getFilters: state => state.filter,
  getFiltersArray: state => state.filters,

  getNewFiles: state => state.report.newFiles,
  getDeletedFilesIds: state => state.report.deletedFilesIds,

  getRoles: state => state.report.role.roles,
  getIsAllRoles: state => state.report.role.isAllRoles,

  getChains: state => state.report.chain.chains,
  getIsAllChains: state => state.report.chain.isAllChains,

  getPdvs: state => state.report.pdvs
}
